import config from '../config'

export default {
  getPageOptions({ keywords, noResults, isMobile, testMode, pageType, currentPage }) {
    if (!this.isPageTypeValid(pageType)) {
      return false
    }
    const platform = isMobile ? 'mobile' : 'desktop'
    const pageTemplateType = noResults ? 'noResults' : 'SLP'
    const channelId =
      config.adSense[pageType].channelId[platform] && config.adSense[pageType].channelId[platform][pageTemplateType]

    return {
      pubId: config.adSense[pageType].pubId,
      query: this.normalizeKeywords(pageType, keywords, this.keywordCleaner.bind(this)),
      adPage: currentPage,
      channel: channelId,
      adtest: testMode ? 'on' : 'off',
      hl: 'en',
      linkTarget: '_blank'
    }
  },

  getPageOptionsParams(params) {
    const {
      pageType,
      categoryName,
      categoryAncestors,
      searchTerm,
      testMode,
      filters,
      appliedFilters,
      noResults,
      isMobile,
      isClearance,
      meta
    } = params
    const appliedFiltersJoined = appliedFilters.map(value => ({ [value.name]: value.values.join() }))
    const allFilters = this.getFilters(pageType, filters)
    const defaultParams = {
      keywords: '',
      noResults,
      isMobile,
      testMode,
      pageType,
      currentPage: meta.currentPage
    }

    const pageOptionsParams = {
      ...defaultParams,
      keywords: (() => {
        let query = ''
        if (String(pageType).toLowerCase() === 'search') {
          query = searchTerm
        } else if (String(pageType).toLowerCase() === 'browse') {
          query = this.getCategoryQuery({ categoryName, categoryAncestors, isClearance })
          const brand = this.getBrandTerms(appliedFiltersJoined, allFilters)
          if (brand) {
            query += `,${brand}`
          }
        }
        query = this.getUniqueTerms(query)
        return query
      })()
    }
    return pageOptionsParams
  },

  getUniqueTerms(query) {
    const prevTerms = query.split(',')
    const nextTerms = []
    let currentTerm = ''
    prevTerms.forEach(v => {
      currentTerm = v.toLowerCase().trim()
      if (!nextTerms.includes(currentTerm)) {
        nextTerms.push(currentTerm)
      }
    })
    return nextTerms.join(',')
  },

  getAdSettings({ container, advertCount, advertWidth }) {
    return {
      container,
      width: advertWidth,
      number: advertCount,
      fontSizeTitle: 14,
      fontSizeDomainLink: 14,
      colorTitleLink: '0C509F',
      colorDomainLink: '0C509F'
    }
  },

  removeStopWords(searchTerm, stopWords) {
    const words = []

    searchTerm.replace(/\b[\w]+\b/g, function(word) {
      if (!stopWords.includes(word)) {
        words.push(word.trim())
      }
    })
    return words.join(' ')
  },

  isPageTypeValid: pageTypeName => {
    const validTypeNames = ['browse', 'search']
    return validTypeNames.includes(pageTypeName)
  },

  getFilters: (pageType, aggregations) => {
    if (!Array.isArray(aggregations)) {
      return []
    }
    return aggregations.filter(v => ['category', 'brands'].includes(String(v.id).toLowerCase()))
  },

  getBrandTerms: appliedFilters => {
    const listOfProperties = {}
    let brands = ''
    const toNormalizedList = (keyName, obj) => {
      if (typeof keyName === 'string') {
        listOfProperties[keyName.toLowerCase()] = obj[keyName]
      }
    }
    Array.isArray(appliedFilters) &&
      appliedFilters.forEach(obj => Object.keys(obj).forEach(k => toNormalizedList(k, obj)))
    if (listOfProperties.hasOwnProperty('brands')) {
      brands = listOfProperties.brands
    }
    return brands
  },

  normalizeKeywords: (pageType, keywords, validator) => {
    const keywordsDirtyList = keywords.split(',')
    const keywordsCleanList = keywordsDirtyList.map(v => validator(pageType, v))
    keywords = keywordsCleanList.filter(v => v !== '').join(', ')
    return keywords
  },

  keywordCleaner(pageType, keyword) {
    return this.removeStopWords(keyword, config.adSense.stopWords).toLowerCase()
  },

  validateQuery: params => {
    const keysToValidate = ['query', 'pubId', 'channel']
    const invalidKeys = Object.keys(params.fullPageOptions).filter(v => {
      return keysToValidate.includes(v) && (params.fullPageOptions[v] === null || params.fullPageOptions[v] === '')
    })
    return invalidKeys.length === 0
  },

  getCategoryQuery: ({ categoryName, categoryAncestors, isClearance = false }) => {
    let term = []
    let parentTerms
    if (categoryName && !(Array.isArray(categoryAncestors) && categoryAncestors.length > 0)) {
      term.push(categoryName)
    } else if (Array.isArray(categoryAncestors)) {
      parentTerms = categoryAncestors
        .filter(v => {
          return String(v.type).toLowerCase() !== 'master category'
        })
        .map(v => {
          if (v.attributes && v.attributes.name) {
            return v.attributes.name
          }
          return v.name
        })
      if (parentTerms.length > 0) {
        parentTerms.push(categoryName)
        term = [...parentTerms]
      }
    }
    if (isClearance) {
      term.unshift(`clearance ${categoryName}`)
    }
    return term.join(', ')
  }
}
